export const APP_NAME = 'RAemPostcodeValidator'
export const zipPattern = /^[\d\s]+$/

export const allowedZipList = [
  54232, 51722, 50782, 54372, 54101, 54701, 50351, 50723, 51801, 50601, 50401, 51761, 50801, 50722, 54234, 54237, 50732,
  54351, 51601, 50346, 55205, 55212, 54931, 50303, 55001, 54204, 54954, 54964, 50771, 54472, 54452, 54901, 54201, 50323,
  54941, 54957, 54906, 51731, 51724, 54477, 51741, 54475, 54974, 50901, 50332, 50713, 54983, 50312, 51743, 51703, 50781,
  50315, 54401, 50003, 50743, 51773, 55203, 51750, 50777, 54377, 54371, 51704, 50343, 50304, 54344, 50353, 54921, 54956,
  51771, 50321, 51745, 50753, 54376, 51721, 54442, 54211, 55204, 55101, 51263, 51791, 50724, 50773, 51793, 50325, 50313,
  54226, 54362, 54342, 54374, 54341, 54227, 54461, 54375, 54103, 50316, 54911, 54102, 54451, 51742, 54455, 54466, 54233,
  54984, 50356, 54301, 54302, 50306, 54952, 54474, 54936, 54946, 50002, 50009, 50341, 50012, 50703, 50327, 55211, 54225,
  55222, 51711, 50731, 51772, 54213, 55102, 54223, 50366, 50791, 54464, 54462, 50705, 50365, 51792, 54922, 54203, 50324,
  50004, 50311, 54443, 54361, 51702, 50733, 50322, 51712, 54236, 50744, 50344, 50715, 51735, 50302, 50361, 51603, 50706,
  50305, 50362, 54963, 51725, 50742, 54973, 50364, 51754, 54923, 54981, 54224, 50745, 50758, 50006, 50011, 54907, 50363,
  50008, 51784, 50354, 51736, 51783, 51764, 29404, 50326, 50752, 54972, 51757, 54221, 50355, 54242, 50301, 51803, 50754,
  54303, 50333, 51732, 54373, 54908, 50712, 54212, 55221, 51755, 55225, 50759, 50352, 54947, 51756, 51701, 54971, 50357,
  50314, 54352, 54948, 54962, 51733, 50704, 50792, 50707, 50711, 50721, 55224, 54932, 54235, 54934, 54454, 54982, 51734,
  50331, 54937, 54912, 54955, 51723, 50702, 54404, 50734
]

export const trackingName = {
  zipCode: 'Poštovní směrovací číslo',
  zipCodeForm: 'WEB_LOCATION_MEMBERSHIP-jak-se-zapojit',
  allowedState: 'Je PSČ povoleno?',
  notAllowedFormName: 'WEB_CONTACT_MEMBERSHIP-neni-povoleno',
  calcModal: 'Membership-kalkulacka'
}
